import { useEffect } from 'react';
import { getUrlExtension } from '@/utils/url/url';

const PRELOADABLE_EXTENSIONS = new Set(['json', 'riv']);

const preloadAsset = (url: string) => {
    const ext = getUrlExtension(url);
    if (ext && PRELOADABLE_EXTENSIONS.has(ext)) {
        fetch(url, { priority: 'low' } as RequestInit).catch(() => {});
    }
};

/**
 * Preloads a fixed list of asset URLs (`.json` / `.riv`) on mount via low-priority fetch.
 * Runs only once — pass a stable array (e.g. computed before the component mounts).
 * Re-renders with a different `urls` reference will not trigger additional fetches.
 */
export const usePreloadAssets = (urls: (string | undefined | null)[]) => {
    useEffect(() => {
        urls.forEach((url) => {
            if (url) preloadAsset(url);
        });
        // Intentionally runs only on mount — urls are expected to be stable
    }, [urls]);
};
